import Vue from 'vue';
import schema from '../../droplet.schema';
const dropletSchema = schema();

export default Vue.component('video-player-temp', {
  template: require('./template.html'),
  name: 'video-player-temp',
  props: {
    file: {
      type: String,
      required: true,
      default: dropletSchema.videoFile,
    },
    id: {
      type: String,
      required: false,
      default: 'no-id',
    },
  },
  mounted() {
    $(document).ready(this.bindPlugin);
  },
  methods: {
    bindPlugin() {
      const ref = this.$refs.drzVideo;
      const $player = $(ref);
      $player.drzVideoPlayer();
    },
    unBindPlugin() {
      const ref = this.$refs.drzVideo;
      const $player = $(ref);
      if (ref) {
        $player.drzVideoPlayer.destroy($player);
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/video-player/components/player/index.js